module.exports = __webpack_public_path__ + "static/img/gzz4.48e752b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/gzz4.png
// module id = SCE6
// module chunks = 2